import { FeatureKind } from "@omni/types/api/product/bff/shared/featureKind.model";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { Col } from "@/components/General/Grid/col.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { ProductFeatureModel } from "../../../helpers";
import { Feature } from "../feature/feature.component";

type FeatureSectionProps = {
    featureKind: FeatureKind;
    featuresGroupedPerKind: Map<string, ProductFeatureModel[]>;
    maxVisibleFeatures: number;
};

const FeatureSection = ({
    featureKind,
    featuresGroupedPerKind,
    maxVisibleFeatures
}: FeatureSectionProps) => {
    const { t } = useGranite();

    const [shouldLimit, setShouldLimit] = useState(true);

    const featureKindFeatureList =
        featuresGroupedPerKind.get(featureKind.code) || [];

    const isSizeAboveMaxCount =
        featureKindFeatureList.length > maxVisibleFeatures;

    return (
        <section className={cn("tw:mb-4")}>
            <div className={cn("tw:border-b tw:border-primary")}>
                <div className={cn("tw:py-2 tw:font-bold")}>
                    {featureKind.name}
                </div>
            </div>
            <div>
                {featureKindFeatureList
                    .slice(0, shouldLimit ? maxVisibleFeatures : 999)
                    .map((featureModel, index) => (
                        <Feature
                            key={`${featureModel.feature.code}-${index}`}
                            featureModel={featureModel}
                            featureKind={featureKind}
                        />
                    ))}
            </div>
            {isSizeAboveMaxCount && (
                <Col className={cn("tw:my-2")}>
                    <Button
                        type="button"
                        color="link"
                        onClick={() => setShouldLimit((state) => !state)}
                        className={cn("tw:p-0")}
                    >
                        {shouldLimit
                            ? t("productDetail.featureList.link.showMore")
                            : t("productDetail.featureList.link.showLess")}{" "}
                        <i
                            className={`las la-angle-${
                                shouldLimit ? "down" : "up"
                            } tw:ml-1`}
                        ></i>
                    </Button>
                </Col>
            )}
        </section>
    );
};

export { FeatureSection };
